import { defaultTagColor, type TagSource } from '@tally/shared';
import { Sparkles, X } from 'lucide-react';

interface TagChipProps {
  name: string;
  color: string | null;
  source?: TagSource;
  onRemove?: () => void;
  disabled?: boolean;
}

export function TagChip({ name, color, source, onRemove, disabled }: TagChipProps) {
  const dot = color ?? defaultTagColor(name);
  return (
    <span
      className="inline-flex max-w-[160px] items-center gap-1 rounded-full border border-border bg-background px-2 py-0.5 text-xs"
      title={source === 'ai' ? `${name} (added by AI)` : name}
    >
      <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: dot }} />
      <span className="truncate">{name}</span>
      {source === 'ai' && <Sparkles className="h-2.5 w-2.5 shrink-0 text-muted-foreground" />}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemove(); }}
          disabled={disabled}
          aria-label={`Remove tag ${name}`}
          className="-mr-1 rounded-full p-0.5 text-muted-foreground hover:bg-accent hover:text-foreground disabled:opacity-50"
        >
          <X className="h-2.5 w-2.5" />
        </button>
      )}
    </span>
  );
}
